import React from 'react';
import { Eye, AlertTriangle, Mail, Globe } from 'lucide-react';

const GeoBlockedPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        
        {/* Header */}
        <div className="text-center mb-12">
          <div className="flex items-center justify-center space-x-2 mb-6">
            <Eye className="w-10 h-10 text-purple-400" />
            <span className="text-2xl font-bold gradient-text serif-display">Coercive Control Patterns</span>
          </div>
        </div>

        {/* Main Content */}
        <div className="glass rounded-2xl p-8 text-center">
          <div className="flex items-center justify-center space-x-3 mb-6">
            <AlertTriangle className="w-12 h-12 text-amber-400" />
            <Globe className="w-12 h-12 text-blue-400" />
          </div>
          
          <h1 className="text-3xl font-bold text-white mb-6 serif-display">
            Service Not Available in Your Region
          </h1>
          
          <div className="text-lg text-gray-300 space-y-4 mb-8">
            <p>
              We're sorry, but CoerciveControlPatterns.com is currently only available to users 
              located in the <strong>United States</strong> and <strong>Canada</strong>.
            </p>
            
            <p>
              This restriction is in place due to legal and jurisdictional requirements 
              for handling sensitive domestic abuse analysis data.
            </p>
          </div>

          {/* Legal Information */}
          <div className="bg-slate-800/50 rounded-lg p-6 mb-8">
            <h2 className="text-xl font-semibold text-white mb-4">Legal Jurisdiction</h2>
            <div className="text-gray-300 space-y-2 text-sm">
              <p>• Our service operates under Wyoming, USA law</p>
              <p>• Data processing occurs within the United States</p>
              <p>• Compliance with North American privacy regulations</p>
              <p>• Specialized domestic violence support framework</p>
            </div>
          </div>

          {/* Support Resources */}
          <div className="bg-amber-900/20 border border-amber-600/30 rounded-lg p-6 mb-8">
            <h2 className="text-xl font-semibold text-amber-300 mb-4">
              Need Help? Local Resources Available
            </h2>
            <div className="text-amber-200 space-y-2 text-sm">
              <p>If you're experiencing domestic abuse or coercive control:</p>
              <ul className="list-disc list-inside space-y-1 mt-2">
                <li>Contact your local domestic violence hotline</li>
                <li>Reach out to national abuse support organizations</li>
                <li>Consult with local legal aid services</li>
                <li>Connect with regional counseling services</li>
              </ul>
            </div>
          </div>

          {/* Contact Information */}
          <div className="border border-slate-600 rounded-lg p-6">
            <div className="flex items-center justify-center space-x-2 mb-3">
              <Mail className="w-5 h-5 text-purple-400" />
              <h3 className="text-lg font-semibold text-white">Questions?</h3>
            </div>
            <p className="text-gray-300 mb-4">
              For questions about service availability or regional restrictions:
            </p>
            <a 
              href="mailto:support@coercivecontrolpatterns.com"
              className="text-purple-400 hover:text-purple-300 font-medium"
            >
              support@coercivecontrolpatterns.com
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeoBlockedPage;